import ShopifyIcon from '@/assets/icons/platforms/shopify.svg';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatedIcon } from './AnimatedIcon';
import { LoadingDots } from './LoadingDots';
import { WelcomeHeading } from './WelcomeHeading';
import { WelcomeText } from './WelcomeText';

export const LoadingState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <AnimatedIcon
        icon={<img src={ShopifyIcon} alt="Shopify" width="48" height="48" />}
        animation="pulse"
        size={48}
      />
      <WelcomeHeading>{t('welcome.shopify.activating.title')}</WelcomeHeading>
      <WelcomeText>{t('welcome.shopify.activating.subtitle')}</WelcomeText>
      <LoadingDots />
    </>
  );
};
